import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentItemDriverMetricQuantityCreateInput } from '../generated/globalTypes';
import { createAssessmentItemDriverMetricQuantityMutation, createAssessmentItemDriverMetricQuantityMutationVariables } from '../generated/createAssessmentItemDriverMetricQuantityMutation';
import { assessmentItemDriverMetricQuantityFieldsFragment } from '../models/AssessmentItemDriverMetricQuantity';

/**
 * Get a callback to create a AssessmentItemDriverMetricQuantity in the store.
 */
export function useCreateAssessmentItemDriverMetricQuantityCallback(): [(model: AssessmentItemDriverMetricQuantityCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createAssessmentItemDriverMetricQuantityMutation, createAssessmentItemDriverMetricQuantityMutationVariables>(
        gql`
            mutation createAssessmentItemDriverMetricQuantityMutation ($model: AssessmentItemDriverMetricQuantityCreateInput!) {
                createAssessmentItemDriverMetricQuantity(model: $model) {
                    ...assessmentItemDriverMetricQuantityFields
                }
            }

            ${assessmentItemDriverMetricQuantityFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: AssessmentItemDriverMetricQuantityCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}